import {
  getGetFrontRichiesteIdModuliIdQueryKey,
  getGetFrontRichiesteIdModuliQueryKey,
  getGetFrontRichiesteIdQueryKey,
  usePostFrontRichiesteIdVotazione,
} from '@framework/api-client';
import { useFillableSubmissionContext } from '@framework/common-web';
import { serializeFormSectionsValues } from '@framework/engine';
import { useFormAugmentedContext } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { getNetworkErrorMessage } from '@framework/ui';
import { message } from 'antd';
import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useQueryClient } from 'react-query';

/**
 * Hook che ritorna la funzione di "submit" per l'invio del voto
 */
export function useVoteWidgetSubmitForm() {
  const { submissionId, submissionModuleId } = useFillableSubmissionContext();
  const [isSucceeded, setIsSucceeded] = useState(false);
  const [loading, setLoading] = useState(false);
  const { schema } = useFormAugmentedContext();
  const methods = useFormContext();

  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const voteMutation = usePostFrontRichiesteIdVotazione({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries(getGetFrontRichiesteIdQueryKey(submissionId!)); // prettier-ignore
        await queryClient.invalidateQueries(getGetFrontRichiesteIdModuliIdQueryKey(submissionId!, submissionModuleId!)); // prettier-ignore
        await queryClient.invalidateQueries(getGetFrontRichiesteIdModuliQueryKey(submissionId!)); // prettier-ignore

        setIsSucceeded(true);
        message.success(t('success-submit-vote-widget.voto-inviato','Voto inviato con successo')); // prettier-ignore
      },
    },
  });

  const onSubmit = useCallback(
    async (values: any) => {
      try {
        if (!submissionId) {
          message.error(t('error-submit-vote-widget.id-richiesta-mancante','Impossibile inviare il voto: ID della richiesta non disponibile')); // prettier-ignore
          return;
        }
        setLoading(true);

        const isValid = await schema.isValid(values);

        await voteMutation.mutateAsync({
          id: submissionId,
          data: {
            statoValidazione: {
              valido: isValid,
              visitato: true,
              completato: isValid,
            },
            valoriSezioni: serializeFormSectionsValues(schema, values),
          },
        });

        methods?.reset(methods.getValues());
      } catch (error) {
        console.error("Errore durante l'invio del voto", error);
        message.error(getNetworkErrorMessage(error,t('error-submit-vote-widget.errore-invio-voto','Si è verificato un errore durante l\'invio del voto. Riprovare.'))); // prettier-ignore
      } finally {
        setLoading(false);
      }
    },
    [voteMutation, submissionId, schema, t, setLoading, methods],
  );

  return { onSubmit, isSucceeded, loading };
}
